export default "__VITE_ASSET__C8e$YaOy__"